/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Extra_Price_Per_DayInputs */

const en_admin_external_booking_edit_extra_price_per_day = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per day`)
};

const de_admin_external_booking_edit_extra_price_per_day = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Tag`)
};

const es_admin_external_booking_edit_extra_price_per_day = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por día`)
};

const fr_admin_external_booking_edit_extra_price_per_day = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par jour`)
};

const nl_admin_external_booking_edit_extra_price_per_day = /** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per dag`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_DayInputs) => LocalizedString} */
const it_admin_external_booking_edit_extra_price_per_day = en_admin_external_booking_edit_extra_price_per_day;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_DayInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_extra_price_per_day = en_admin_external_booking_edit_extra_price_per_day;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_DayInputs) => LocalizedString} */
const pl_admin_external_booking_edit_extra_price_per_day = en_admin_external_booking_edit_extra_price_per_day;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_DayInputs) => LocalizedString} */
const hu_admin_external_booking_edit_extra_price_per_day = en_admin_external_booking_edit_extra_price_per_day;

/** @type {(inputs: Admin_External_Booking_Edit_Extra_Price_Per_DayInputs) => LocalizedString} */
const ro_admin_external_booking_edit_extra_price_per_day = en_admin_external_booking_edit_extra_price_per_day;

/**
* | output |
* | --- |
* | "per day" |
*
* @param {Admin_External_Booking_Edit_Extra_Price_Per_DayInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_extra_price_per_day = /** @type {((inputs?: Admin_External_Booking_Edit_Extra_Price_Per_DayInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Extra_Price_Per_DayInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_extra_price_per_day(inputs)
	if (locale === "de") return de_admin_external_booking_edit_extra_price_per_day(inputs)
	if (locale === "es") return es_admin_external_booking_edit_extra_price_per_day(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_extra_price_per_day(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_extra_price_per_day(inputs)
	if (locale === "it") return it_admin_external_booking_edit_extra_price_per_day(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_extra_price_per_day(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_extra_price_per_day(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_extra_price_per_day(inputs)
	return ro_admin_external_booking_edit_extra_price_per_day(inputs)
});
export { admin_external_booking_edit_extra_price_per_day as "admin.external_booking_edit.extra_price_per_day" }